import { render, staticRenderFns } from "./TreeChartTwo.vue?vue&type=template&id=0ef4c22d&scoped=true"
import script from "./TreeChartTwo.vue?vue&type=script&lang=js"
export * from "./TreeChartTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef4c22d",
  null
  
)

export default component.exports